<template>
  <div>
    <base-pie-chart
      v-show="!printable || (!imgData && printable)"
      :height="height ? height : null"
      :chart-data="getChartData"
      :options="getChartOptions"
      @chartCreated="setChart"
    />
    <img :height="height ? height : 200" :src="imgData" v-show="printable && imgData">
  </div>
</template>

<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import chartMixin from './mixins/chartMixin';
import BasePieChart from './base/BasePieChart';


Chart.defaults.global.plugins.datalabels.display = false;

export default {
  name: 'LabelledPieChart',
  components: {
    BasePieChart,
    ChartDataLabels,
  },
  data: () => ({
    chart: null,
    imgData: null,
  }),
  props: {
    height: {
      type: Number,
    },
    printable: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [chartMixin],
  methods: {
    setChart(chart) {
      this.chart = chart;
    },
    animationComplete() {
      if (!this.chart || !this.printable) {
        return;
      }
      this.imgData = this.chart.toBase64Image();
    },
  },
};
</script>



// WEBPACK FOOTER //
// LabelledPieChart.vue?47f16917